export { default } from './es/icons/QuestionTwoTone';